import type { ReactNode } from 'react';
import { cx } from '../cx';

export type Step = { id: string; title: ReactNode; body?: ReactNode };

export type StepsProps = {
  /** In their real order: numbers here mean sequence, so use Steps only for a true sequence. */
  steps: Step[];
  headingLevel?: 2 | 3;
  className?: string;
};

/** Numbered step panels for how-to guides. Each step has an id so a table of contents can link to it. */
export function Steps({ steps, headingLevel = 2, className }: StepsProps) {
  const Heading = `h${headingLevel}` as 'h2';
  return (
    <ol className={cx('flex flex-col gap-4', className)}>
      {steps.map((step, i) => (
        <li
          key={step.id}
          id={step.id}
          className="flex scroll-mt-24 gap-4 rounded-jc-container border border-jc-card-border bg-jc-surface p-5 md:p-6"
        >
          <span
            aria-hidden="true"
            className="inline-grid size-10 shrink-0 place-items-center rounded-full bg-jc-action type-subheading text-jc-on-action"
          >
            {i + 1}
          </span>
          <div className="flex min-w-0 flex-col gap-1.5">
            <Heading className="type-heading text-jc-ink">{step.title}</Heading>
            {step.body ? <div className="text-sm text-jc-ink-secondary">{step.body}</div> : null}
          </div>
        </li>
      ))}
    </ol>
  );
}
